import { Box } from "@mui/material";
import { DotLegalAlert, DotLegalDialog, DotLegalHeader, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { useAvoidRiskDialog } from "./AvoidRiskDialog.hooks";
import { TreatmentDialogProps } from "./TreatmentDialogs.types";
import { useTreatmentDialogStyles } from "./TreatmentDialogs.styles";

function AvoidRiskDialog(props: TreatmentDialogProps) {
    const { translateString } = useTranslation();
    const styles = useTreatmentDialogStyles();
    const { isAlreadyAvoided, reason, setReason, okButtonDisabled, onSave, inProgress } = useAvoidRiskDialog(props);

    return (
        <DotLegalDialog
            open
            header={translateString("riskTreatmentTypeAvoid")}
            buttonOkText={translateString("save")}
            onDialogClose={props.onClose}
            onOkClick={onSave}
            okButtonDisabled={okButtonDisabled}
            inProgress={inProgress}
            size={"md"}
        >
            <Box sx={styles.content}>
                <Box sx={styles.subHeader}>
                    <DotLegalHeader center marginTop={-1} marginBottom={0} fontWeight={400} headerStyle="small">
                        {translateString("riskTreatmentAvoidDescription")}
                    </DotLegalHeader>
                </Box>

                {isAlreadyAvoided && <DotLegalAlert warningText={translateString("riskTreatmentAlreadyAvoided")} severity={"info"} />}

                <Box sx={styles.sectionContent}>
                    <DotLegalTextField
                        label={translateString("justification")}
                        value={reason}
                        onChange={setReason}
                        multiline
                        rows={3}
                        noMargin
                        debounce={false}
                    />
                </Box>
            </Box>
        </DotLegalDialog>
    );
}

export default AvoidRiskDialog;
